module.exports = __webpack_public_path__ + "static/media/mj.cd55285f.jpg";